var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 11C20 14.866 16.866 18 13 18C9.13401 18 6 14.866 6 11C6 7.13401 9.13401 4 13 4C16.866 4 20 7.13401 20 11Z",
    fill: "#F9A01B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3807 2.52222C7.9754 2.83942 4.5 6.51385 4.5 11C4.5 11.9402 4.65266 12.8448 4.93455 13.6903C2.07675 12.809 0 10.147 0 7C0 3.13401 3.13401 0 7 0C9.16289 0 11.0967 0.980948 12.3807 2.52222Z",
    fill: "#F9A01B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistIcon);
export default __webpack_public_path__ + "static/media/hist-icon.f2dd6954d6efbdb3c231278abc8353a8.svg";
export { ForwardRef as ReactComponent };